module.exports = __webpack_public_path__ + "img/logo-white.1f96002f.svg";